import * as stagesCase from "../../Stages/StagesCase";
import { ProductSpecificFormDefinition } from "../../../types/ProductService/ProductService";
import { OtherContract } from "../../../types/Products/ContractLaw/OtherContract";

const otherProductSpecificDefinition = (
  product: OtherContract
): ReturnType<ProductSpecificFormDefinition<OtherContract>> => [
  {
    type: "ValidatorTextField",
    path: `${product.productClassName}.contractNumber`,
    isDisabled: ({ product }) => product.stage >= stagesCase.STAGE_LAWSUIT,
  },
  {
    type: "ValidatorDateField",
    path: `${product.productClassName}.endOfContractDate`,
    isDisabled: ({ product }) => product.stage >= stagesCase.STAGE_CHECKED,
    isHidden: ({ product }) => {
      return product.objectiveLawFirm !== "cancellationConfirmation";
    },
  },
];

export default otherProductSpecificDefinition;
